<app-animal-details-container [animal]="animal()" [partialHeight]="true" (navigatedBack)="back()" (onClose)="close()" [showLocator]="false">
    <div class="dropdown">
        <button
            class="btn btn-info btn-info-shadow dropdown-toggle w-100"
            data-bs-target="#filterCollapse"
            data-bs-toggle="collapse"
            type="button">
            {{ historicalLocationStore.filter() }}
        </button>
        <div
            class="collapse"
            id="filterCollapse">
            @for (option of filterOptions; track option) {
                <div>
                    <div (click)="setFilter(option)"
                        class="btn card m-1"
                        data-bs-target="#filterCollapse"
                        data-bs-toggle="collapse">{{ option }}
                    </div>
                </div>
            }
        </div>
    </div>
</app-animal-details-container>
